module.exports = function (project) {
  const defaultConfig = require('./config.default.js')
  const projectConfig = require(`./config.${project}.js`)
  return Object.assign(defaultConfig, projectConfig)
}